import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ChipsModule } from 'primeng/chips';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PickListModule } from 'primeng/picklist';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { AuthModule } from '../auth/auth.module';
import { AddPositionComponent } from './components/add-position/add-position.component';
import { AnagraficaEditorComponent } from './components/anagrafica-editor/anagrafica-editor.component';
import { DestinatariComponent } from './components/dati-documento/components/destinatari.component';
import { MittenteComponent } from './components/dati-documento/components/mittente.component';
import { DatiDocumentoComponent } from './components/dati-documento/dati-documento.component';
import { DeclassificaDialogComponent } from './components/declassifica-dialog.component';
import { DistruzioneDialogComponent } from './components/distruzione-dialog.component';
import { DocumentiListCircleComponent } from './components/documenti-list/components/documenti-list-circle.component';
import { DocumentiListComponent } from './components/documenti-list/documenti-list.component';
import { ModificaStatoDialogComponent } from './components/modifica-stato-dialog.component';
import { PositionSelectComponent } from './components/position-select.component';
import { PositionValueComponent } from './components/position-value.component';
import { ProrogaOverlayComponent } from './components/proroga-overlay.component';
import { RegisterResultTableComponent } from './components/register-result-table.component';
import { RicevutaTrasmissioneDialogComponent } from './components/ricevuta-trasmissione-dialog.component';
import { RiferimentiDialogComponent } from './components/riferimenti-dialog.component';
import { StateArchiveDialogComponent } from './components/state-archive-dialog.component';
import { AnagraficaAutocompleteDirective } from './directives/anagrafica-autocomplete.directive';
import { AnagraficaViewDirective } from './directives/anagrafica-view.directive';
import { BarredPipe } from './pipes/barred.pipe';
import { ClassificaI18nPipe } from './pipes/classifica-i18n.pipe';
import { DataStoricoPipe } from './pipes/data-storico.pipe';
import { ExcerptPipe } from './pipes/excerpt.pipe';
import { FascicoloLabelPipe } from './pipes/fascicolo-label.pipe';
import { HighlightDistruttoPipe } from './pipes/highlight-distrutto.pipe';
import { HighlightMatchPipe } from './pipes/highlight-match.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';
import { LineThroughPipe } from './pipes/line-through.pipe';
import { LinethroughDistruttoPipe } from './pipes/linethrough-distrutto.pipe';
import { PosizionebreadcrumbPipe } from './pipes/posizionebreadcrumb.pipe';
import { ReplaceTildePipe } from './pipes/replace-tilde.pipe';
import { VisualizzaCopiaperDialogComponent } from './components/copia-per/visualizza-copiaper-dialog.component';
import { TabellaCopiaperComponent } from './components/copia-per/tabella-copiaper.component';
import { DateFilterComponent } from './components/date-filter.component';
import { FieldsetModule } from 'primeng/fieldset';
import { FileSizePipe } from './pipes/file-size.pipe';
import { SoggettoDialogComponent } from './components/soggetto-dialog/soggetto-dialog.component';
import { FormatLongNotePipe } from './pipes/format-long-note.pipe';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    TableModule,
    ButtonModule,
    AutoCompleteModule,
    ReactiveFormsModule,
    CalendarModule,
    InputTextModule,
    InputTextareaModule,
    InputGroupModule,
    DropdownModule,
    TooltipModule,
    TreeTableModule,
    PaginatorModule,
    DialogModule,
    PickListModule,
    ListboxModule,
    OverlayPanelModule,
    ToastModule,
    AuthModule,
    CheckboxModule,
    SplitButtonModule,
    FieldsetModule,
    ChipsModule,
    InputSwitchModule,
    SoggettoDialogComponent,
    FormatLongNotePipe
  ],
  exports: [
    DocumentiListComponent,
    RiferimentiDialogComponent,
    DatiDocumentoComponent,
    DestinatariComponent,
    PositionSelectComponent,
    PositionValueComponent,
    ProrogaOverlayComponent,
    HighlightMatchPipe,
    HighlightPipe,
    HighlightDistruttoPipe,
    LinethroughDistruttoPipe,
    PosizionebreadcrumbPipe,
    BarredPipe,
    AnagraficaEditorComponent,
    AnagraficaAutocompleteDirective,
    AnagraficaViewDirective,
    RegisterResultTableComponent,
    ReplaceTildePipe,
    LineThroughPipe,
    ClassificaI18nPipe,
    ExcerptPipe,
    AddPositionComponent,
    FascicoloLabelPipe,
    DataStoricoPipe,
    StateArchiveDialogComponent,
    DeclassificaDialogComponent,
    DistruzioneDialogComponent,
    ModificaStatoDialogComponent,
    RicevutaTrasmissioneDialogComponent,
    TabellaCopiaperComponent,
    VisualizzaCopiaperDialogComponent,
    DateFilterComponent,
    FileSizePipe
  ],
  declarations: [
    DocumentiListComponent,
    DocumentiListCircleComponent,
    RiferimentiDialogComponent,
    DatiDocumentoComponent,
    DestinatariComponent,
    MittenteComponent,
    PositionSelectComponent,
    PositionValueComponent,
    ProrogaOverlayComponent,
    HighlightMatchPipe,
    HighlightPipe,
    HighlightDistruttoPipe,
    LinethroughDistruttoPipe,
    PosizionebreadcrumbPipe,
    BarredPipe,
    AnagraficaEditorComponent,
    ClassificaI18nPipe,
    AnagraficaAutocompleteDirective,
    AnagraficaViewDirective,
    RegisterResultTableComponent,
    ReplaceTildePipe,
    LineThroughPipe,
    ExcerptPipe,
    AddPositionComponent,
    FascicoloLabelPipe,
    DataStoricoPipe,
    StateArchiveDialogComponent,
    DeclassificaDialogComponent,
    DistruzioneDialogComponent,
    ModificaStatoDialogComponent,
    RicevutaTrasmissioneDialogComponent,
    TabellaCopiaperComponent,
    VisualizzaCopiaperDialogComponent,
    DateFilterComponent,
    FileSizePipe
  ],
  providers: [],
})
export class SharedModule { }
